import React from 'react';
import classNames from 'classnames';
import Container from "@scentregroup/ui/components/container";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketplaceContainer = _ref => {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Container, {
    type: "large",
    className: classNames(className, style.MarketplaceContainer),
    "data-id": "marketplace-container_index_MarketplaceContainer_Container",
    children: children
  });
};